import { useState, useEffect } from "react";
import styles from "./Soc.module.css";
import Button from "../button/Button";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Error404 from "../404Error/404Error";

const SocScreen = () => {
  const [level, setLevel] = useState(null);
  const [consumedUnit, setConsumedUnit] = useState(null);
  const [socData, setSocData] = useState(null);
  const [pollingId, setPollingId] = useState(null);
  const [stopChargeGif, setStopChargeGif] = useState(false);
  const [noToken, setNoToken] = useState(false);
  const [chargingInProgressSecondScreen, setChargingInProgressSecondScreen] =
    useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const backSession = sessionStorage.getItem("cameFromSessionTicket");

  useEffect(() => {
    sessionStorage.setItem("cameFromSocScreen", true);
    let intervalId;

    const fetchSOCData = async () => {
      const access_token = searchParams.get("token");
      const booking_id = searchParams.get("booking_id");

      if (!access_token || backSession === "true") {
        setNoToken(true);
        clearInterval(intervalId);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}transaction/everest/v1/get-soc?booking_id=${booking_id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
          }
        );

        const data = await response.json();
        setSocData(data);

        if (
          data?.meta?.status_code === 4000 ||
          data?.meta?.status_code === 1001
        ) {
          setNoToken(true);
          clearInterval(intervalId);
          return;
        }

        if (data?.data?.units_consumed !== null) {
          setChargingInProgressSecondScreen(true);
          setConsumedUnit(data?.data?.units_consumed);
        }

        if (data?.data?.soc) setLevel(data?.data?.soc);
      } catch (error) {
        console.error("Failed to fetch SOC data:", error);
      }
    };

    fetchSOCData();
    intervalId = setInterval(fetchSOCData, 30000);
    setPollingId(intervalId);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const getBatteryColor = () => {
    if (level === null) return "transparent";
    if (level > 50) return "#4CAF50";
    if (level > 20) return "#FFC107";
    return "#F44336";
  };

  const stopCharging = async () => {
    setStopChargeGif(true);
    const access_token = searchParams.get("token");
    const booking_id = searchParams.get("booking_id");

    if (pollingId) clearInterval(pollingId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CHARGE_CONTROL}api/v1/charging/remote-stop`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
          body: JSON.stringify({
            transaction_id: parseInt(booking_id),
            source: "everest-webapp",
          }),
        }
      );

      const data = await response.json();

      if (
        data?.meta?.status_code === 3000
      ) {
        setStopChargeGif(false);
        navigate(
          `/get-charging-soc?booking_id=${booking_id}&token=${access_token}`
        );
      } else {
        setStopChargeGif(false);
        navigate(
          `/transaction-detail?booking_id=${booking_id}&token=${access_token}`
        );
      }
    } catch (error) {
      console.error("Failed to fetch SOC data:", error);
    }
  };

  if (noToken) {
    return <Error404 />;
  }

  if (!chargingInProgressSecondScreen) {
    return (
      <div className={styles.imageContainer}>
        <span className={styles.heading}>Charging successfully initiated</span>
        <img src="/assets/LoaderGif.gif" className={styles.pinImage} />
        <p className={styles.description}>
          Please wait fetching{" "}
          <span className={styles.boldPercentage}>Battery Percentage</span>
        </p>
        <p className={styles.description} style={{ marginTop: "4px" }}>
          It may take upto a minute for the car to draw current
        </p>
      </div>
    );
  }

  if (socData?.meta?.status_code === 1000 && chargingInProgressSecondScreen)
    return (
      <div className={styles.carOuter}>
        {!stopChargeGif && (
          <>
            <div className={styles.carname}>
              <p>{socData?.data?.vehicle_name}</p>
            </div>
            <div className={styles.carimageContainer}>
              <img src="/assets/carImage.svg" className={styles.carImage} />
            </div>
          </>
        )}

        {stopChargeGif ? (
          <div className={styles.waitingOuter}>
            <div className={styles.imageContainer}>
              <img src="/assets/LoaderGif.gif" className={styles.pinImage} />
              <p className={styles.description}>Please wait...</p>
            </div>
          </div>
        ) : (
          <div className={styles.batterInfo}>
            <div className={styles.batteryStatus}>
              <div className={styles.batteryStatusOne}>
                <span className={styles.batteryStatusOneHeading}>
                  {socData?.data?.type == "DC" ? "Battery SOC" : "Battery"}
                </span>
                <div className={styles.batteryContainer}>
                  <div className={styles.batteryOuter}>
                    {/* Battery fill container */}
                    <div className={styles.batteryInner}>
                      <div
                        className={styles.batteryFill}
                        style={{
                          height: `${level}%`,
                          backgroundColor: getBatteryColor(),
                        }}
                      />
                    </div>
                    {/* ----- */}

                    <img
                      src="/assets/BatteryTop.svg"
                      className={styles.BatteryTop}
                    />
                  </div>

                  <span className={styles.timeRemaining}>
                    {socData?.data?.type === "DC"
                      ? socData?.data?.soc
                      : "Charging in Progress"}
                  </span>
                </div>
              </div>

              <div className={styles.unitConsumed}>
                <p>Units Consumed</p>
                <p>Units Consumed/Total Units Allotted</p>
                <div className={styles.thunderContainer}>
                  <img src="/assets/Thunder.svg" className={styles.thunder} />
                  <p>
                    {consumedUnit} / {socData?.data?.total_units_allotted}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={styles.buttonContainer}>
          {!stopChargeGif && (
            <Button
              value={"Stop Charging"}
              disabled={false}
              className={"enableConnectorButton"}
              onClick={stopCharging}
            />
          )}
        </div>
      </div>
    );
};

export default SocScreen;
